import { render, staticRenderFns } from "./QueryNoticeByNoticeNo.vue?vue&type=template&id=08d7c36c&"
import script from "./QueryNoticeByNoticeNo.vue?vue&type=script&lang=ts&"
export * from "./QueryNoticeByNoticeNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports